export default __webpack_public_path__ + "static/media/paper.9e5d49e7.jpeg";